<template>
  <div class="map-wrapper">
    <div id='map'></div>
    <div id="distance" class="distance-container"></div>
    <div class="top-right" :class="{active: isFullInfo, 'active-full': encumbranceDetail[encIndex] === 'true'}">
      <button @click="showLeftMenuDisplayMedia()" class="open-left-menu">
        <img src="@img/down.svg" alt="">
      </button>
      <button @click="setMapDefault()" class="home" title="Вернуть в исходное положение">
        <img src="@img/home.svg" alt="">
      </button>
      <div class="control print">
        <button @click="showContentControl('isPrint')" class="print-map" title="Печатать карту">
          <img src="@img/print-map.svg" alt="">
        </button>
        <div class="control-content print-content" :class="{active: isPrint}">
          <!-- <span>Введите ширину</span>
          <input class="form-control" type="text" v-model="docWidth">
          <span>Введите высоту</span>
          <input class="form-control" type="text" v-model="docHeight"> -->
          <span>Введите dpi</span>
          <input class="form-control" type="text" v-model="dpi">
          <button class="btn accent-btn" @click="printCanvas()">Печатать</button>
          <div v-if="isConvert" class="preloader print-pre">
            <svg class="loader print-load" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 340 340">
              <circle cx="170" cy="170" r="160" stroke="#4E53E7"/>
              <circle cx="170" cy="170" r="135" stroke="#404041"/>
              <circle cx="170" cy="170" r="110" stroke="#4E53E7"/>
              <circle cx="170" cy="170" r="85" stroke="#404041"/>
            </svg>
          </div>
        </div>
      </div>
      <div class="control layers">
        <div @click="showContentControl('isLayers')" class="show-layers" title="Слои">
          <img src="@img/layers.svg" alt="">
        </div>
        <div class="control-content layers-content" :class="{active: isLayers}">
          <div class="style-control">
            <div class="layers-control">
              <span
                class="layer"
                :class="{'visible-layer': layer.visibility}"
                v-for="(layer, index) in LayersControl"
                :key="layer.id"
                @click="toggleVisibility(layer, index)"
              >
                {{ layer.name }}
              </span>
            </div>
            <button :class="{'active-style': mapStyle === 'satellite'}" @click="setMapStyle('satellite')">Спутник</button><br>
            <button :class="{'active-style': mapStyle === 'schema'}" @click="setMapStyle('schema')">Схема</button>
          </div>
        </div>
      </div>
      <div class="control legend">
        <div @click="showContentControl('isLegend')" class="show-legend" title="Легенда">
          <span style="background-color:rgba(128, 0, 255, .5"></span>
          <span style="background-color:rgba(255, 0, 0, .5"></span><br>
          <span style="background-color:rgba(0, 128, 0, .5"></span>
          <span style="background-color:rgba(0, 128, 255, .5"></span>
        </div>
        <div class="control-content legend-content" :class="{active: isLegend}">
          <div class="legend-item">
            <div class="legend-label" style="background-color:rgba(128, 0, 255, .5"></div>
            <span>Собственность физических лиц</span>
          </div>
          <div class="legend-item">
            <div class="legend-label" style="background-color:rgba(0, 255, 0, .5)"></div>
            <span>Собственность юридических лиц</span>
          </div>
          <div class="legend-item">
            <div class="legend-label" style="background-color:rgba(0, 128, 0, .5)"></div>
            <span>Собственность РФ</span>
          </div>
          <div class="legend-item">
            <div class="legend-label" style="background-color:rgba(0, 128, 255, .5)"></div>
            <span>Собственность субъекта РФ</span>
          </div>
          <div class="legend-item">
            <div class="legend-label" style="background-color:rgba(255, 128, 64, .5)"></div>
            <span>Собственность муниципального образования</span>
          </div>
          <div class="legend-item">
            <div class="legend-label" style="background-color:rgba(255, 0, 255, .5)"></div>
            <span>Собственность сельских поселений</span>
          </div>
          <div class="legend-item">
            <div class="legend-label" style="background-color:rgba(0, 128, 255, .5)"></div>
            <span>Собственность РФ, суб. РФ, мун.обр.</span>
          </div>
          <div class="legend-item">
            <div class="legend-label" style="background-color:rgba(204, 0, 0, .5)"></div>
            <span>Иная собственность</span>
          </div>
          <div class="legend-item">
            <div class="legend-label" style="background-color:rgba(255, 128, 128, .5)"></div>
            <span>Общая долевая собственность</span>
          </div>
          <div class="legend-item">
            <div class="legend-label" style="background-color:rgba(128, 64, 0, .5)"></div>
            <span>Пожизненное наследуемое владение</span>
          </div>
          <div class="legend-item">
            <div class="legend-label" style="background-color:rgba(128, 128, 0, .5)"></div>
            <span>Постоянное (бессрочное) пользование</span>
          </div>
          <div class="legend-item">
            <div class="legend-label" style="background-color:rgba(255, 255, 0, .5)"></div>
            <span>Земельные участки, на которые не разграничен вид права</span>
          </div>
          <div class="legend-item">
            <div class="legend-label" style="background-color:rgba(255, 0, 0, .5)"></div>
            <span>Фонд перераспределения</span>
          </div>
          <div class="legend-item">
            <div class="legend-label" style="background-color:rgba(51, 51, 51, .5)"></div>
            <span>Иные права</span>
          </div><div class="legend-item">
            <div class="legend-label">
              <img src="@img/tlu-1.svg" alt="">
            </div>
            <span>Залежь</span>
          </div>
          <div class="legend-item">
            <div class="legend-label">
              <img src="@img/tlu-2.svg" alt="">
            </div>
            <span>Многолетние насаждения</span>
          </div>
          <div class="legend-item">
            <div class="legend-label">
              <img src="@img/tlu-3.svg" alt="">
            </div>
            <span>Пастбище</span>
          </div>
          <div class="legend-item">
            <div class="legend-label">
              <img src="@img/tlu-5.svg" alt="">
            </div>
            <span>Сенокос</span>
          </div>
          <div class="legend-item">
            <div class="legend-label">
              <img src="@img/tlu-4.svg" alt="">
            </div>
            <span>Пашня</span>
          </div>
        </div>
      </div>
      <div class="control main-search">
        <button @click="showContentControl('isSearch')" class="show-layers" title="Поиск">
          <img src="@img/main-search.svg" alt="">
        </button>
        <div class="control-content main-search-content" :class="{active: isSearch}">
          <div class="main-search-control">
            <vue-dadata
              placeholder="Введите адрес..."
              class="search_address"
              token="6431764af9c9f37f4bd21cb4268759cc66589f81"
              :locationOptions='dadataLocationOptions'
              :onChange="infoAddress"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="change-map-control">
      <div class="filter-check">
        <div v-if="isMapFilter" class="preloader map-preloader">
          <svg class="loader map-loader" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 340 340">
            <circle cx="170" cy="170" r="160" stroke="#4E53E7"/>
            <circle cx="170" cy="170" r="135" stroke="#404041"/>
            <circle cx="170" cy="170" r="110" stroke="#4E53E7"/>
            <circle cx="170" cy="170" r="85" stroke="#404041"/>
          </svg>
        </div>
        <div class="input-wrap">
          <label title="Скрывать участки, которые не удовлетворяют указанным фильтрам">
            <input v-model="acceptFilterToMap" name="locality" type="checkbox" hidden>
            <span>Применять фильтры к карте</span>
          </label>
        </div>
      </div>
    </div>
    <div class="change-style-layer">
      <button @click="isChangeStyle = !isChangeStyle" class="change-style-layer-button">
        <img src="@img/brush.svg" alt="">
      </button>
      <div :class="{active: isChangeStyle}" class="change-style-layer-content">
        <codemirror v-model="defaultLayersString" :options="cmOption"/>
        <button class="btn accent-btn" @click="changeStyle()">Применить</button>
      </div>
    </div>
    <div class="area-info" :class="{active: isFullInfo, 'active-full': encumbranceDetail[encIndex] === 'true'}" v-if="drawArea !== 0">
      <span>Площадь: {{drawArea}} м²</span>
    </div>
    <transition name="popup-opacity">
      <PopupVue
        v-if="isPopup"
        @closePopup="closePopup"
      >
        <template #content>
          <transition name="popup-scale">
            <PopupSelectLayerVue @closePopup="closePopup" :arrFeatures="arrFeatures" :selectLayerProps="selectLayer"></PopupSelectLayerVue>
          </transition>
        </template>
      </PopupVue>
    </transition>
  </div>
</template>

<script>
// theme css
import 'codemirror/theme/monokai.css'

// language
import 'codemirror/mode/javascript/javascript.js'

import PopupVue from '@/components/PopupVue.vue'
import PopupSelectLayerVue from '@/components/popup/PopupSelectLayerVue.vue'
import { eventBus } from '@/main.js'
import gql from 'graphql-tag'
import mapboxgl from 'mapbox-gl'
// import MapboxDraw from '@mapbox/mapbox-gl-draw'
import RulerControl from 'mapbox-gl-controls/lib/ruler'
import * as turf from '@turf/turf'
import 'mapbox-gl/dist/mapbox-gl.css'
import axios from 'axios'
import VueDadata from 'vue-dadata'
var printPdf = require('mapbox-print-pdf')

const GET_LAND_GOMETRY_BY_PK = gql`
query getLandGeomtryByPk($pk: Int) {
  land(pk: $pk){
    pk
    contourSet {
      edges {
        node {
          geometry {
            type
            coordinates
          }
        }
      }
    }
    location {
      text
    }
  }
}
`

const GET_LAND_INFO_POPUP = gql`
query getLandInfoPopup($pk: Int) {
  land(pk: $pk) {
    location {
      text
      okatoSp {
        text
      }
    }
    areaBydoc
    rightSet {
      edges {
        node {
          encumbranceSet {
            edges {
              node {
                encumbranceType {
                  code
                }
              }
            }
          }
        }
      }
    }
  }
}
`

export default {
  name: 'MapComponent',
  components: {
    VueDadata,
    PopupVue,
    PopupSelectLayerVue
  },
  data () {
    return {
      popup: null,
      selectLayer: null,
      isPopup: false,
      map: null,
      draw: null,
      mapStyle: 'schema',
      contourList: {},
      dotTimer: null,
      isRent: false,
      isLegend: false,
      isLayers: false,
      isPrint: false,
      isSearch: false,
      isConvert: false,
      isChangeStyle: false,
      arrFeatures: [],
      missClick: null,
      docWidth: null,
      docHeight: null,
      initSaveId: null,
      dpi: null,
      acceptFilterToMap: true,
      savedIdList: 'empty',
      cmOption: {
        tabSize: 4,
        styleActiveLine: true,
        lineNumbers: true,
        line: true,
        mode: {
          name: 'javascript',
          json: true
        },
        lineWrapping: true,
        theme: 'monokai'
      },
      defaultSources: {
        hightlight: { // ЕГО НЕТ В СТИЛЯХ КАРТЫ! Я ДОБАВЛЯЛ НЕ УДАЛЯТЬ. Нужен для подсвечивания полигонов
          type: 'geojson',
          data: {
            type: 'Feature',
            coordinates: null
          }
        },
        satellite: { // ЕГО НЕТ В СТИЛЯХ КАРТЫ! Я ДОБАВЛЯЛ НЕ УДАЛЯТЬ. Нужен для кнопки "спутник"
          type: 'raster',
          tiles: [
            'https://mt1.google.com/vt/lyrs=y&x={x}&y={y}&z={z}'
          ],
          tileSize: 256
        },
        osm: {
          type: 'raster',
          tiles: [
            'https://a.tile.openstreetmap.org/{z}/{x}/{y}.png',
            'https://b.tile.openstreetmap.org/{z}/{x}/{y}.png',
            'https://c.tile.openstreetmap.org/{z}/{x}/{y}.png'
          ],
          tileSize: 256
        },
        test: {
          type: 'vector',
          tiles: [
            // 'http://192.168.2.250:8000/api/v1/land/vector_tiles/{z}/{x}/{y}.mvt'
            this.$store.getters.value('host') + '/ugeoapi/api/v1/land/vector_tiles/{z}/{x}/{y}.mvt'
          ],
          promoteId: {
            'layer': 'id'
          }
        }
      },
      defaultLayersString: '',
      defaultLayers: [
        {
          'id': 'background-map',
          'type': 'background',
          'paint': {
            'background-color': 'white'
          }
        },
        { // ЕГО НЕТ В СТИЛЯХ КАРТЫ! Я ДОБАВЛЯЛ! НЕ УДАЛЯТЬ. Нужен для кнопки "спутник"
          'id': 'satellite',
          'type': 'raster',
          'source': 'satellite',
          'metadata': {
            'mapbox:layer:caption': 'Google.com'
          },
          'layout': {
            'visibility': 'none'
          }
        },
        {
          'id': 'openstreetmap',
          'type': 'raster',
          'source': 'osm',
          'metadata': {
            'mapbox:layer:caption': 'OpenStreetMap.org'
          }
        },
        {
          id: 'polygon-fill',
          type: 'fill',
          source: 'test',
          'source-layer': 'layer',
          layout: {},
          paint: {
            'fill-color': ['case', ['all', ['==', ['get', 'right_type'], '1001000000'], ['any', ['==', ['get', 'sp'], '7003000000'], ['==', ['get', 'sp'], '7003001000'], ['==', ['get', 'sp'], '7003002000']]], '#8000FF', ['all', ['==', ['get', 'right_type'], '1001000000'], ['any', ['==', ['get', 'sp'], '7002000000'], ['==', ['get', 'sp'], '7002001000'], ['==', ['get', 'sp'], '7002002000'], ['==', ['get', 'sp'], '7002003000']]], '#00FF00', ['all', ['==', ['get', 'right_type'], '1001000000'], ['==', ['get', 'sp'], '7001001001']], '#008000', ['all', ['==', ['get', 'right_type'], '1001000000'], ['==', ['get', 'sp'], '7001001002']], '#0080FF', ['all', ['==', ['get', 'right_type'], '1001000000'], ['==', ['get', 'sp'], '7001001003']], '#FF8040', ['all', ['==', ['get', 'right_type'], '1001000000'], ['==', ['get', 'sp'], '7001001099']], '#FF00FF', ['all', ['==', ['get', 'right_type'], '1001000000'], ['any', ['==', ['get', 'sp'], '7001001000'], ['==', ['get', 'sp'], '7001000000']]], '#150BE3', ['all', ['==', ['get', 'right_type'], '1001000000'], ['any', ['==', ['get', 'sp'], null], ['==', ['get', 'sp'], '7003003000'], ['==', ['get', 'sp'], '7001002000'], ['==', ['get', 'sp'], '7001003000'], ['==', ['get', 'sp'], '7001004000']]], '#CC0000', ['any', ['==', ['get', 'right_type'], '1002000000'], ['==', ['get', 'right_type'], '1003000000']], '#FF8080', ['==', ['get', 'right_type'], '1006000000'], '#804000', ['==', ['get', 'right_type'], '1007000000'], '#808000', ['==', ['get', 'right_type'], '1099000001'], '#FFFF00', ['==', ['get', 'right_type'], '1099000002'], '#FF0000', '#333333'],
            'fill-opacity': 0.5,
            'fill-outline-color': ['case', ['==', ['get', 'cad_register_geom'], false], 'red', 'black']
          }
        },
        { // ЕГО НЕТ В СТИЛЯХ КАРТЫ! Я ДОБАВЛЯЛ! НЕ УДАЛЯТЬ. Нужен для подсветки полигонов
          'id': 'hightlight-border',
          'type': 'line',
          'source': 'hightlight',
          'paint': {
            'line-color': 'red',
            'line-width': 2
          }
        },
        {
          id: 'polygon-label',
          type: 'symbol',
          source: 'test',
          'source-layer': 'layer',
          minzoom: 13,
          layout: {
            'symbol-placement': 'point',
            'text-field': ['get', 'reg_num'],
            'icon-image': ['case',
              ['==', ['get', 'is_rented'], true],
              ['concat', 'A', ['get', 'tlu']],
              ['get', 'tlu']
            ],
            'icon-anchor': 'top',
            'text-size': 10
          },
          paint: {'icon-translate': [0, 5], 'text-halo-width': 2, 'text-halo-color': 'white'}
        }
      ],
      ngwSources: {},
      ngwLayers: [],
      LayersControl: [],
      dadataLocationOptions: {
        'locations': [
          {'region': 'Воронежская'}
        ]
      },
      rulerActive: false,
      drawActive: false,
      drawArea: 0,
      newDrawData: {},
      oldDrawData: {}
    }
  },
  computed: {
    isFullInfo () {
      return this.$store.getters.value('isFullInfo')
    },
    encumbranceDetail () {
      return this.$store.getters.value('encumbranceDetail')
    },
    isMapFilter () {
      return this.$store.getters.value('isMapFilter')
    },
    encIndex () {
      return this.$store.getters.value('encIndex')
    }
  },
  created () {
    eventBus.$on('boundFeature', this.boundFeature)
    eventBus.$on('setFilterMap', this.setFilterMap)
  },
  beforeDestroy () {
    document.removeEventListener('click', this.missClick)
    eventBus.$off('boundFeature')
    eventBus.$off('setFilterMap')
  },
  mounted () {
    this.initMap()
    this.defaultLayersString = JSON.stringify(this.defaultLayers[3].paint['fill-color'], undefined, 4)
    this.missClick = (item) => {
      let q = document.querySelector('.header')
      let w = document.querySelector('.mapboxgl-canvas')
      if (item.target === q || item.target === w) {
        this.showContentControl()
      }
    }
    document.addEventListener('click', this.missClick)
  },
  watch: {
    acceptFilterToMap (newVal) {
      if (newVal && this.savedIdList !== 'empty') {
        this.setFilterMap(this.savedIdList)
        // this.savedIdList = 'empty'
      } else if (!newVal) {
        this.setFilterMap(null, true)
      }
    }
  },
  methods: {
    closePopup () {
      this.isPopup = false
    },
    changeStyle () {
      this.map.setPaintProperty('polygon-fill', 'fill-color', JSON.parse(this.defaultLayersString))
    },
    infoAddress (allInfo) {
      const data = allInfo.data
      this.map.flyTo({
        center: [data.geo_lon, data.geo_lat],
        zoom: 14
      })
    },
    showContentControl (typeControl) {
      if (typeControl === 'isLegend') {
        this.isLegend = !this.isLegend
        this.isLayers = false
        this.isPrint = false
        this.isSearch = false
      } else if (typeControl === 'isLayers') {
        this.isLayers = !this.isLayers
        this.isLegend = false
        this.isPrint = false
        this.isSearch = false
      } else if (typeControl === 'isPrint') {
        this.isPrint = !this.isPrint
        this.isLayers = false
        this.isLegend = false
        this.isSearch = false
      } else if (typeControl === 'isSearch') {
        this.isSearch = !this.isSearch
        this.isLayers = false
        this.isLegend = false
        this.isPrint = false
      } else {
        this.isSearch = false
        this.isLayers = false
        this.isLegend = false
        this.isPrint = false
      }
    },

    toggleVisibility (layer, index) {
      this.map.setLayoutProperty(layer.id, 'visibility', layer.visibility ? 'none' : 'visible')
      this.LayersControl[index].visibility = !this.LayersControl[index].visibility
    },

    setMapStyle (styleName) {
      this.mapStyle = styleName
      if (styleName === 'satellite') {
        this.map.setLayoutProperty('satellite', 'visibility', 'visible')
        this.map.setLayoutProperty('openstreetmap', 'visibility', 'none')
      } else {
        this.map.setLayoutProperty('satellite', 'visibility', 'none')
        this.map.setLayoutProperty('openstreetmap', 'visibility', 'visible')
      }
    },

    setFilterMap (idArr, force) {
      // console.log('idArr', idArr)
      // console.log('force', force)
      if (force !== true) { // force === true только при выключении флага
        this.savedIdList = idArr
      }
      if (force !== true) { // если не принудительно, то смотрим на то включен ли флаг
        if (!this.acceptFilterToMap) { // если фильтры выключены не применять
          this.$store.dispatch('SET_VALUE', {key: 'isMapFilter', value: false})
          return
        }
      }
      if (this.map === null || !this.map.loaded()) { // если карта не загрузилась
        // console.log('map not load')
        // if (idArr !== undefined && idArr !== null && Array.isArray(idArr) && idArr.length > 0) {
        this.initSaveId = idArr
        setTimeout(() => {
          this.setFilterMap(this.initSaveId)
        }, 700)
        // }
        // this.$store.dispatch('SET_VALUE', {key: 'isMapFilter', value: false})
        return
      }
      if (idArr === null || idArr === undefined || !Array.isArray(idArr)) { // если непонятное значение то сбросиь фильтры(для сброса передается null)
        // console.log('clearMapFilters')
        this.map.setFilter('polygon-fill', null) // очистить фильтры
        this.map.setFilter('polygon-label', null) // очистить фильтры
        this.$store.dispatch('SET_VALUE', {key: 'isMapFilter', value: false})
        return
      }
      if (idArr.length === 0) { // если длина ноль
        this.map.setFilter('polygon-fill', ['in', 'idwwww', 'ssss']) // рандомный фильтр, который скрывает все
        this.map.setFilter('polygon-label', ['in', 'idwwww', 'ssss']) // рандомный фильтр, который скрывает все
        this.$store.dispatch('SET_VALUE', {key: 'isMapFilter', value: false})
      } else { // если длина не ноль, то устанавливаем фильтр на переданные ИД
        // console.log('set fucking filters')
        this.hightlightPolygon(null) // сбросить выделенную фичу
        if (this.popup !== null) {
          this.popup.remove()
        }
        this.map.setFilter('polygon-fill', ['in', 'id', ...idArr])
        this.map.setFilter('polygon-label', ['in', 'id', ...idArr])
        this.$store.dispatch('SET_VALUE', {key: 'isMapFilter', value: false})
      }
    },

    async getGeometryByLandPk (pk) {
      let response = await this.$apollo.query({
        query: GET_LAND_GOMETRY_BY_PK,
        fetchPolicy: 'no-cache',
        variables: {
          pk: pk
        }
      })

      let geom = null
      try {
        geom = {
          type: 'FeatureCollection',
          features: []
        }
        response.data.land.contourSet.edges.forEach(edge => {
          geom.features.push({
            type: 'Feature',
            geometry: edge.node.geometry
          })
        })
        // geom = response.data.land.contourSet.edges[0].node.geometry
        // console.log('response.data.land.contourSet', response.data.land.contourSet)
      } catch (error) {
        geom = null
        console.error('fail get geometry in response', response)
      }
      return geom
    },

    boundFeature (data) { // принимает массив координат или pk. Делает перемещает карту к данным координатам
      // console.log('data', data)
      if (data === undefined || data === null) {
        this.hightlightPolygon(null)
        return
      }
      if (data.geometry !== undefined) { // если передали координаты
        let bounds = this.getBoundsFromGeometry(data.geometry)
        this.map.fitBounds(bounds)
      } else if (data.pk !== undefined) {
        this.getGeometryByLandPk(data.pk).then(featureCollection => {
          // console.log(featureCollection)
          if (featureCollection !== null && featureCollection.features.length > 0) {
            // let bounds = this.getBoundsFromGeometryMix(featureCollection.features[0].geometry)
            if (data.index !== undefined) {
              let bounds = turf.bbox(featureCollection.features[data.index]) // ZZZZ
              this.map.fitBounds(bounds, {
                padding: 30
              })
              this.hightlightPolygon(featureCollection[data.index])
            } else {
              let bounds = turf.bbox(featureCollection) // ZZZZ
              this.map.fitBounds(bounds, {
                padding: 30
              })
              this.hightlightPolygon(featureCollection)
            }
          } else {
            console.warn('fail get bound from geomerty', featureCollection)
            this.hightlightPolygon(null)
          }
        })
      } else {
        console.error('else else else')
      }
    },

    hightlightPolygon (featureCollection) {
      // console.log('featureCollection hightlightPolygon', featureCollection)
      if (featureCollection === null) {
        var data = {
          'type': 'Feature',
          'geometry': null
        }
        this.map.getSource('hightlight').setData(data)
      } else {
        this.map.getSource('hightlight').setData(featureCollection)
      }
    },

    async initMap () {
      let GLYPHS = 'mapbox://fonts/mapbox/{fontstack}/{range}.pbf'
      // let GLYPHS = 'https://bg-map.govvrn.ru/glyphs/{fontstack}/{range}.pbf'
      let KEY = 'no-token'
      mapboxgl.accessToken = KEY
      this.map = new mapboxgl.Map({
        container: 'map',
        style: {
          version: 8,
          name: 'mapdev.io',
          preserveDrawingBuffer: false,
          center: [
            40.5,
            51
          ],
          zoom: 7,
          sprite: process.env.NODE_ENV === 'development' ? 'http://localhost:8080/static/sprite/sprite' : `${this.$store.getters.value('host')}/static/sprite/sprite`,
          glyphs: GLYPHS,
          sources: this.defaultSources,
          layers: this.defaultLayers
        },
        transformRequest: (url, resourceType) => {
          if (resourceType === 'Tile' && url.startsWith(this.$store.getters.value('host'))) {
            return {
              url: url,
              credentials: 'same-origin',
              headers: {
                'Authorization': 'JWT ' + this.$cookies.get('access')
              }
            }
          }
        },
        center: [40.760654386292344, 50.879154360027655], // starting position [lng, lat]
        zoom: 7 // starting zoom
      })

      this.map.dragRotate.disable()
      var scale = new mapboxgl.ScaleControl({
        maxWidth: 80,
        unit: 'metric'
      })

      this.map.addControl(scale)
      this.map.addControl(new mapboxgl.NavigationControl())

      this.map.addControl(new RulerControl())
      this.map.on('ruler.on', () => { this.rulerActive = true })
      this.map.on('ruler.off', () => { this.rulerActive = false })

      // eslint-disable-next-line
      var draw = new MapboxDraw({
        displayControlsDefault: false,
        controls: {
          polygon: true,
          trash: true
        }
      })
      if (!/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) {
        this.map.addControl(draw)
      }
      this.map.on('draw.create', updateArea)
      this.map.on('draw.delete', updateArea)
      this.map.on('draw.update', updateArea)
      this.map.on('draw.actionable', () => {
        if (this.drawActive === true) {
          this.drawActive = false
        } else {
          this.drawActive = true
        }
      })
      var self = this
      function updateArea (e) {
        var data = draw.getAll()
        self.newDrawData = self.updateDrawData(data, e)
        draw.deleteAll()
        draw.add(self.newDrawData)
        if (self.newDrawData.features.length > 0) {
          var area = turf.area(self.newDrawData)
          var roundedArea = Math.round(area * 100) / 100
          self.drawArea = roundedArea
        } else {
          self.drawArea = 0
        }
      }

      let tooltip = new mapboxgl.Popup({
        closeButton: false
      })

      // курсор при наведении
      this.map.on('mousemove', 'polygon-fill', (e) => {
        if (this.rulerActive === false && this.drawActive === false) {
          let coordinates = e.lngLat
          var bbox = [[e.point.x, e.point.y], [e.point.x, e.point.y]]
          let feature = this.map.queryRenderedFeatures(bbox, {layers: ['polygon-fill']})[0]
          let tooltipC = this.createTooltipBlock(e.features[0].properties)
          if (feature !== undefined) {
            tooltip
              .setLngLat(coordinates)
              .setDOMContent(tooltipC)
              .addTo(this.map)
          }
          this.map.getCanvas().style.cursor = 'pointer'
        }
      })

      // курсор при наведении(вернуть)
      this.map.on('mouseleave', 'polygon-fill', () => {
        if (this.rulerActive === false && this.drawActive === false) {
          this.map.getCanvas().style.cursor = ''
          tooltip.remove()
        }
      })

      // this.map.on('click', e => {
      //   this.hightlightPolygon(null) // сброс выделения на клик вне
      // })

      this.map.on('click', e => {
        if (this.rulerActive === false && this.drawActive === false) {
          let coordinates = e.lngLat
          var bbox = [[e.point.x, e.point.y], [e.point.x, e.point.y]]
          let arrFeat = []
          let feature = this.map.queryRenderedFeatures(bbox, {layers: ['polygon-fill']})[0]
          this.map.queryRenderedFeatures(e.point).forEach(item => {
            if (item.layer.id === 'polygon-fill') {
              arrFeat.push(item)
              // console.log(item)
            }
          })
          this.selectLayer = (featurePopup) => {
            let popup = this.createPopupBlock(featurePopup.properties, e)
            this.popup = new mapboxgl.Popup()
              .setLngLat(coordinates)
              .setDOMContent(popup)
              .addTo(this.map)
            this.getGeometryByLandPk(featurePopup.properties.id).then(featureCollection => {
              if (featureCollection !== null) {
                this.hightlightPolygon(featureCollection)
              } else {
                console.error('fail get bound from geomerty', featureCollection)
                this.hightlightPolygon(null)
              }
            })
          }
          if (feature) {
            if (arrFeat.length >= 2) {
              // console.log(this.map.queryRenderedFeatures(e.point))
              this.arrFeatures = arrFeat
              this.isPopup = true
            } else {
              this.selectLayer(feature)
            }
          } else {
            this.hightlightPolygon(null)
          }
        }
      })

      this.map.on('load', async e => {
        try { // получение ngw слоев
          let res = await axios.get(this.$store.getters.value('ngwHost'))
          res.data.wmsserver_service.layers.forEach(item => {
            this.ngwSources[item.keyname] = {
              type: 'raster',
              tiles: [this.$store.getters.value('ngwHost') + '/wms?bbox={bbox-epsg-3857}&format=image/png&service=WMS&version=1.1.1&request=GetMap&srs=EPSG:3857&transparent=true&width=256&height=256&layers=' + item.keyname],
              tileSize: 256
            }
            this.ngwLayers.push({
              id: item.keyname,
              type: 'raster',
              source: item.keyname,
              'metadata': {
                'mapbox:layer:caption': item.display_name
              },
              layout: {
                'visibility': 'none'
              }
            })
            this.map.addSource(item.keyname, {
              type: 'raster',
              tiles: [this.$store.getters.value('ngwHost') + '/wms?bbox={bbox-epsg-3857}&format=image/png&service=WMS&version=1.1.1&request=GetMap&srs=EPSG:3857&transparent=true&width=256&height=256&layers=' + item.keyname],
              tileSize: 256
            })
            this.map.addLayer({
              id: item.keyname,
              type: 'raster',
              source: item.keyname,
              'metadata': {
                'mapbox:layer:caption': item.display_name
              },
              layout: {
                'visibility': 'none'
              }
            })
            this.LayersControl.push({
              name: item.display_name,
              id: item.keyname,
              visibility: false
            })
          })
        } catch (error) {
          console.warn('fail get wms layers', error)
        }
        this.allSources = {...this.defaultSources, ...this.ngwSources}
        this.allLayers = [...this.defaultLayers, ...this.ngwLayers]
        setTimeout(() => {
          if (this.initSaveId !== null) {
            this.setFilterMap(this.initSaveId)
          }
        }, 200)
      })
    },

    updateDrawData (data, e) { // ищет пересечения
      if (data.features.length < 2) {
        return data
      }
      let featureList = []
      if (e.type === 'draw.create') {
        let newFeature = e.features[0]
        let hasIntersect = false
        for (let i of data.features) { // проход по всем фичам
          if (i.id === newFeature.id) {
            continue
          }
          let intersect = turf.intersect(i, JSON.parse(JSON.stringify(newFeature)))
          if (intersect !== null) {
            hasIntersect = true
            let id = i.id
            let newPolygon = turf.difference(i, JSON.parse(JSON.stringify(newFeature)))
            i.id = id
            featureList.push(newPolygon)
          } else {
            featureList.push(i)
          }
        }
        if (!hasIntersect) { // если ни с какой из фич не пересекается, то добавить
          featureList.push(newFeature)
        }
      } else {
        return data
      }
      data.features = featureList
      return data
    },

    getFeatureFromWms (e) {
      let _url = this.createUrlGetFeature([e.lngLat.lng, e.lngLat.lat], e.point)
      // _url = null // ZZZZ
      if (_url !== null) {
        return axios.get(_url)
      } else {
        return Promise.resolve(null)
      }
    },

    createUrlGetFeature (lngLat, xy) {
      let _visibleLayers = []
      this.ngwLayers.forEach(layer => {
        // let mapLayer = this.map.getLayer(layer.id)
        let noDataNgw = ['geo_les', 'pkk']
        if (noDataNgw.indexOf(layer.id) === -1 && this.map.getLayoutProperty(layer.id, 'visibility') === 'visible') {
          _visibleLayers.push(layer.id)
        }
      })
      if (_visibleLayers.length === 0) {
        return null
      }
      // let pointConvert = this.WGStoMercator(lngLat)
      let bbox = this.map.getBounds()
      let leftDown = this.WGStoMercator([bbox._sw.lng, bbox._sw.lat])
      let rightTop = this.WGStoMercator([bbox._ne.lng, bbox._ne.lat])
      bbox = leftDown.concat(rightTop)
      let mapContainer = document.getElementById('map')
      let size = [mapContainer.offsetWidth, mapContainer.offsetHeight]
      let params = {
        service: 'WMS',
        version: '1.1.1',
        request: 'GetFeatureInfo',
        bbox: String(bbox),
        srs: 'EPSG:3857',
        width: size[0],
        height: size[1],
        layers: _visibleLayers,
        QUERY_LAYERS: _visibleLayers,
        INFO_FORMAT: 'application/json',
        x: xy.x,
        y: xy.y
      }
      let url = `${this.$store.getters.value('ngwHost')}/wms?SERVICE=${params.service}&VERSION=${params.version}&REQUEST=${params.request}&BBOX=${params.bbox}&SRS=${params.srs}&WIDTH=${params.width}&HEIGHT=${params.height}&QUERY_LAYERS=${params.QUERY_LAYERS}&INFO_FORMAT=${params.INFO_FORMAT}&X=${params.x}&Y=${params.y}&FEATURE_COUNT=10`
      return url
    },

    WGStoMercator (coords) {
      let x = coords[0] * 20037508.34 / 180
      let y = Math.log(Math.tan((90 + coords[1]) * Math.PI / 360)) / (Math.PI / 180)
      y = y * 20037508.34 / 180
      return [x, y]
    },

    setMapDefault () {
      this.map.flyTo({
        center: [40.760654386292344, 50.879154360027655],
        zoom: 7
      })
    },

    createTooltipBlock (props) {
      let popupWrapper = document.createElement('div')
      let popupName = document.createElement('div')
      popupWrapper.className = 'popup-wrapper'
      popupWrapper.className = 'popup-wrapper-tooltip'
      popupName.className = 'popup-name'
      let pName = document.createElement('p')
      pName.innerText = props.reg_num
      popupName.appendChild(pName)
      popupWrapper.appendChild(popupName)

      return popupWrapper
    },

    createPopupBlock (props, e) {
      let popupWrapper = document.createElement('div')
      let popupName = document.createElement('div')
      // let popupLocation = document.createElement('div')
      let popupArea = document.createElement('div')
      let popupLocation = document.createElement('div')
      let popupNgw = document.createElement('div')
      let popupRent = document.createElement('img')
      popupWrapper.className = 'popup-wrapper'
      popupName.className = 'popup-name'
      popupLocation.className = 'popup-location'
      popupNgw.className = 'popup-ngw'
      popupRent.src = require('@img/rent.svg')
      popupRent.className = 'rent-img'
      popupRent.setAttribute('title', 'В аренде')
      let pName = document.createElement('p')
      let pLocation = document.createElement('p')
      pName.innerText = props.reg_num
      popupName.appendChild(pName)
      popupLocation.appendChild(pLocation)
      popupWrapper.appendChild(popupName)
      popupWrapper.appendChild(popupLocation)
      popupWrapper.appendChild(popupArea)
      popupWrapper.appendChild(popupNgw)
      this.appendNgwData(e, popupNgw)
      let buttonDetail = document.createElement('div')
      buttonDetail.className = 'popup-detail'
      buttonDetail.title = 'Детальный просмотр'
      let img = document.createElement('img')
      img.src = require('@img/full.svg')
      buttonDetail.addEventListener('click', clickEvent => {
        if (props.id !== null && props.id !== undefined) {
          eventBus.$emit('selectLandByPk', props.id)
        } else {
          console.error('land id(pk) is null')
        }
      })
      buttonDetail.appendChild(img)
      this.startDotLoading(popupArea)
      this.$apollo.query({
        query: GET_LAND_INFO_POPUP,
        variables: {
          pk: props.id
        }
      }).then(resp => {
        this.stopDotLoading()
        if (resp.data.land.areaBydoc !== null) {
          popupArea.innerHTML = `Площадь: ${resp.data.land.areaBydoc} м<sup>2</sup>`
        } else {
          popupArea.innerHTML = 'Площадь неизвестна'
        }
        if (resp.data.land.location !== null && resp.data.land.location.okatoSp !== null) {
          popupLocation.innerText = 'С/п: ' + resp.data.land.location.okatoSp.text
        } else {
          popupLocation.innerHTML = 'Сельское поселение не указано'
        }
        /* if (resp.data.land.location !== null) {
          pLocation.title = resp.data.land.location.text
          if (resp.data.land.location.text !== undefined && resp.data.land.location.text !== null) {
            if (resp.data.land.location.text.length > 88) {
              pLocation.innerText = resp.data.land.location.text.substring(0, 88) + '...'
            } else {
              pLocation.innerText = resp.data.land.location.text
            }
          } else {
            pLocation.innerText = 'Нет подробного адреса'
          }
        } else {
          pLocation.innerText = 'Нет подробного адреса'
        } */

        this.isRent = false
        for (let i = 0; i < resp.data.land.rightSet.edges.length; i++) {
          this.isRent = resp.data.land.rightSet.edges[i].node.encumbranceSet.edges.find(encum => {
            return encum.node.encumbranceType.code === '22006000000'
          })
          if (this.isRent) {
            break
          }
        }

        if (this.isRent) {
          popupWrapper.prepend(popupRent)
        }
      }).catch(err => {
        console.error('fail get popup info', err)
        this.stopDotLoading()
        // pLocation.innerText = 'Нет подробного адреса'
        popupArea.innerText = 'Площадь неизвестна'
      })

      popupWrapper.appendChild(buttonDetail)
      return popupWrapper
    },

    appendNgwData (e, block) {
      // console.log('e', e)
      // console.log('block', block)
      this.getFeatureFromWms(e).then(response1 => {
        if (response1 !== null) {
          response1.data.forEach(layer => {
            if (layer.features.length === 0) { // если в слое нет данных не создавать для него блоки
              return
            }
            // муторная генерация блоков
            let layerName = document.createElement('div')
            let layerProperties = document.createElement('div')
            layerName.className = 'popup_ngw_layer-name'
            layerProperties.className = 'popup_ngw_layer-properteis'
            layerName.innerText = layer.display_name

            for (let featureIndex = 0; featureIndex < layer.features.length; featureIndex++) {
              let featureBlock = document.createElement('div')
              featureBlock.className = 'popup_ngw_layer-properteis_feature'
              let _feature = layer.features[featureIndex]
              for (let key in _feature) {
                let propItem = document.createElement('div')
                propItem.className = 'popup_ngw_layer-properteis_item'
                let propItemName = document.createElement('p')
                let propItemValue = document.createElement('p')
                propItemName.innerText = key
                propItemName.title = key
                propItemValue.innerText = _feature[key]
                propItemValue.title = _feature[key]
                propItem.appendChild(propItemName)
                propItem.appendChild(propItemValue)
                featureBlock.appendChild(propItem)
              }
              layerProperties.appendChild(featureBlock)
            }
            block.appendChild(layerName)
            block.appendChild(layerProperties)
          })
        }
      }).catch(err => {
        console.error('can not get data from wms', err)
      })
    },

    startDotLoading (block) {
      let s = '.'
      this.dotTimer = setInterval(() => {
        try {
          s = s.length > 3 ? '.' : s + '.'
          block.innerText = s
        } catch (error) {
          this.stopDotLoading()
        }
      }, 300)
    },

    stopDotLoading (timerId) {
      clearInterval(this.dotTimer)
    },

    showLeftMenuDisplayMedia () {
      this.$store.dispatch('SET_VALUE', {key: 'leftMenuDisplayMedia', value: true})
    },

    printCanvas () {
      this.isConvert = true
      printPdf
        .build()
        .margins({
          top: 1,
          right: 1,
          left: 1,
          bottom: 1
        })
        .format({width: 297, height: 210, unit: 'mm', name: 'my-format'})
        .landscape()
        .dpi(this.dpi)
        .print(this.map, mapboxgl)
        .then(pdf => {
          pdf.save('map.pdf')
        })
        .catch(error => {
          console.warn('Failed to print ', error)
        }).finally(() => {
          this.isConvert = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.vue-codemirror {
  width: 700px;
}
.map-preloader {
  position: absolute;
  width: 100px;
  top: 0;
}

.map-loader {
  top: -5px;
  left: -70px;
}

.print-pre {
  position: absolute;
  border-radius: 8px;
  width: 100%;
  top: 0;
  left: 0;
}

.print-load {
  top: 35%;
  left: 35%;
}

#map {
  width: 100%;
  height: 100%;
}
.map-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
}
.top-right {
  position: absolute;
  display: flex;
  align-items: flex-start;
  top: 10px;
  left: 20px;
  transition: .3s;
  &.active {
    left: 135px;
    &.active-full {
      left: 595px;
    }
  }
}
.home,
.print-map,
.main-search {
  padding: 7px 9px 6px;
  background-color: #fff;
  border: 1px solid #e6e6e6;
  border-radius: 8px;
  box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.08);
}
.print-map {
  @media screen and (max-width: 768px) {
    display: none;
    padding: none;
  }
}
.open-left-menu {
  display: none;
  padding: 7px 10px;
  margin-right: 15px;
  background-color: #fff;
  border: 1px solid #e6e6e6;
  border-radius: 8px;
  box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.08);
  img {
    width: 100%;
    height: 100%;
    transform: rotate(-90deg);
  }
  @media screen and (max-width: 768px) {
    display: block;
  }
}
.control {
  margin-left: 15px;
  cursor: pointer;
  &-content {
    position: absolute;
    border-radius: 8px;
    padding: 10px;
    left: 0;
    top: 100px;
    opacity: 0;
    visibility: hidden;
    background-color: #fff;
    transition: .3s;
    &:after {
      position: absolute;
      content: "";
      top: -8px;
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 0 7px 8px 7px;
      border-color: transparent transparent #fff transparent;
    }
    &.active {
      top: 51px;
      opacity: 1;
      visibility: visible;
      @media screen and (max-width: 768px){
        width: 100vw;
        height: auto;
        position: fixed;
        max-height: calc(100vh - 200px);
        top: 150px;
        left: 0;
        z-index: 99;
        overflow-y: auto;
      }
    }
  }
}
.legend {
  border-radius: 8px;
  .show-legend {
    justify-content: center;
    align-items: center;
    padding: 4px 8px;
    font-family: 'Montserrat_B';
    background-color: #fff;
    border: 1px solid #e6e6e6;
    border-radius: 8px;
    box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.08);
    span {
      display: inline-block;
      width: 10px;
      height: 10px;
    }
  }
  &-content {
    width: 300px;
    @media screen and (max-width: 768px){
      width: 100vw;
      height: auto;
      position: fixed;
      max-height: calc(100vh - 200px);
      top: 150px;
      left: 0;
      z-index: 99;
      overflow-y: auto;
    }
    &.active {
      top: 50px;
      opacity: 1;
      visibility: visible;
      @media screen and (max-width: 768px){
        position: fixed;
        top: 150px;
        left: 0;
        z-index: 99;
        overflow-y: auto;
      }
    }
    &:after {
      left: 190px;
    }
  }
  &-item {
    display: flex;
    align-items: center;
    margin-bottom: 5px;
    font-size: 12px;
  }
  &-label {
    flex: none;
    width: 20px;
    height: 20px;
    margin-right: 5px;
  }
}

.layers {
  .show-layers {
    justify-content: center;
    align-items: center;
    padding: 7px 8px 6px;
    font-family: 'Montserrat_B';
    background-color: #fff;
    border: 1px solid #e6e6e6;
    border-radius: 8px;
    box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.08);
  }
  &-control {
    border-bottom: 1px solid #e6e6e6;
    margin-bottom: 5px;
  }
  &-content {
    &:after {
      left: 133px;
      @media screen and (max-width: 768px){
        display: none;
      }
    }
  }
}

.print {
  @media screen and (max-width: 768px){
    display: none;
  }
  &-content {
    width: 180px;
    span {
      font-size: 14px;
      display: inline-block;
      margin-bottom: 5px;
    }
    .form-control {
      display: block;
      font-size: 12px;
      height: 30px;
      max-width: 60px;
      margin-bottom: 15px;
    }
    .btn {
      font-size: 14px;
    }
    &:after {
      left: 75px;
    }
  }
}

.main-search {
  @media screen and (max-width: 768px){
    display: none;
  }
  .search_address {
    margin-left: 0;
  }
  &-content {
    &:after {
      left: 248px;
    }
  }
}

.change-map-control {
  position: absolute;
  width: 330px;
  bottom: 15px;
  right: 40px;
  border-radius: 8px;
  background-color: white;
  padding: 10px 20px;
  box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.08);
  @media screen and (max-width: 768px){
    display: none;
  }
}

.change-style-layer {
  @media screen and (max-width: 768px){
    display: none;
  }
  position: absolute;
  top: 70%;
  // transform: translateY(-80%);
  right: 10px;
  &-button {
    background-color: #fff;
    padding: 6px 6px 4px;
    border-radius: 4px;
    box-shadow: 0 0 0 2px rgba(0,0,0,.1);
  }
  &-content {
    position: absolute;
    bottom: 0;
    right: -300px;
    background-color: #fff;
    visibility: hidden;
    opacity: 0;
    padding: 10px;
    border-radius: 8px;
    box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.2);
    transition: .3s;
    &.active {
      right: 50px;
      visibility: visible;
      opacity: 1;
    }
  }
  .btn {
    margin-top: 20px;
    float: right;
  }
}

.style-control {
  bottom: 40px;
  padding: 7px 15px;
  button {
    margin: 5px 0;
    font-size: 14px;
  }
}
.active-style {
  font-family: 'Montserrat_B';
  color: #4E53E7;
}
.layer {
  display: block;
  user-select: none;
  white-space: nowrap;
  font-size: 14px;
  margin-bottom: 10px;
}
.visible-layer {
  font-family: 'Montserrat_B';
  color: #4E53E7;
}

.search_address {
  height: 44px;
  @media screen and (max-width: 768px){
    display: none;
  }
  margin-left: 15px;
  width: 250px;
}
.area-info {
  width: auto;
  position: absolute;
  bottom: 50px;
  left: 10px;
  border-radius: 8px;
  background-color: white;
  padding: 10px 20px;
  box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.08);
  transition: .3s;
  @media screen and (max-width: 768px){
    display: none;
  }
  span {
    font-size: 12px;
    font-weight: bold;
    font-family: 'Montserrat_B';
  }
  &.active {
    left: 135px;
    &.active-full {
      left: 595px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/main/MapComponent.vue